import type { Action } from 'redux';
import type { UpdateAdLinkActionPayload } from '../AdLinks.types';

export const UPDATE_AD_LINKS = 'AD_LINKS_UPDATE_AD_LINKS';

export const updateAdLinks = (payload: UpdateAdLinkActionPayload): UpdateAdLinksAction => {
  return {
    type: UPDATE_AD_LINKS,
    data: payload,
  };
};

export type UpdateAdLinksAction = Action<typeof UPDATE_AD_LINKS> & { data: UpdateAdLinkActionPayload };
